
import IConstants from "@/common/constants/IConstants.js";

const ForceNewUtilMixin = {

	computed: {

		isParentScreenForceNew() {
			return this.parentScreen === IConstants.PARENT_SCREEN.FORCE_NEWS;
		},

		// displayForms format: "INV#-1,AUT#-1,ADD#-1,BOO#-1,MAI#-1,NUM#-1,TEL#-1,NAM#-1,PWD#0,FXO#-1,CFO#-1,BOL#-1"
		forceNewType() {
			if (this.isParentScreenForceNew) {
				if (!this.displayForms || this.displayForms === '') {
					return IConstants.FORCE_NEW_TYPE.NOT_FORCE_NEW_TYPE;
				}

				if (!this.displayFormCode || this.displayFormCode === '') {
					return IConstants.FORCE_NEW_TYPE.NOT_FORCE_NEW_TYPE;
				}

				// character ',', '#' is from value which BE add to database
				let forceNewTypes = this.displayForms.split(',');
				let mapForm = new Map();
				for (let i = 0; i < forceNewTypes.length; i++) {
					let formDetails = forceNewTypes[i].split('#');
					mapForm.set(formDetails[0], formDetails[1]);
				}
				return parseInt(mapForm.get(this.displayFormCode));
			}

			return IConstants.FORCE_NEW_TYPE.NOT_FORCE_NEW_TYPE;
		},

		isForceNewTypeOn() {
			return this.forceNewType === IConstants.FORCE_NEW_TYPE.ON;
		},

		isForceNewTypeForceOn() {
			return this.forceNewType === IConstants.FORCE_NEW_TYPE.FORCE_ON;
		}
	},

	methods: {
		handleForceNewEvent() {
			if (this.isParentScreenForceNew) {
				this.$emit("onChangeChildFormStatus", this.$v.$invalid, this.blockName);
			}
		},

		handleChangeFileInput() {
			this.$emit('onChangeFileUpload');
		}
	}
};

export default ForceNewUtilMixin;
